<template>
  <v-menu bottom left transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :ripple="false"
        icon
        v-bind="attrs"
        v-on="on"
        class="notification-btn"
        :color="$vuetify.theme.dark ? 'greenMain' : '#171717'"
      >
        <v-icon>mdi-bell-outline</v-icon>
        <v-badge
          color="red-lighten-1"
          :content="totalCount"
          :value="totalCount > 0"
          overlap
        >
        </v-badge>
      </v-btn>
    </template>

    <v-card class="notification-card">
      <v-list :color="$vuetify.theme.dark ? 'primary ' : 'white'">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list three-line :color="$vuetify.theme.dark ? 'primary ' : 'white'">
          <template v-if="notifications && notifications.length > 0">
            <v-list
              three-line
              :color="$vuetify.theme.dark ? 'primary ' : 'white'"
            >
              <v-list-item-group v-model="selected" multiple>
                <div v-for="(item, index) in notifications" :key="item.id">
                  <v-list-item @click="navigateToPage(item)">
                    <template v-slot:default="{ active }">
                      <v-list-item-icon>
                        <v-icon color="greenMain">mdi-circle-small</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.comment"
                        ></v-list-item-title>
                        <v-list-item-action-text>
                          Total: {{ item.count }}
                        </v-list-item-action-text>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-divider
                    v-if="index < notifications.length - 1"
                    :key="index"
                    :color="$vuetify.theme.dark ? '#1E3046 ' : '#E0EAF2'"
                  ></v-divider>
                </div>
              </v-list-item-group>
            </v-list>
          </template>

          <template v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-center"
                  >No notifications</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-list>

      <v-divider></v-divider>
      <v-btn
        :disabled="!notifications || notifications.length === 0"
        tile
        style="width: 100%"
        color="greenMain"
        small
        elevation="0"
        @click="markAllAsRead"
        >Mark all as read</v-btn
      >
    </v-card>
  </v-menu>
</template>

<script>
import { ADMINNOTIFICATION__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    selected: [],
  }),
  computed: {
    ...mapState("adminnotification", ["notifications"]),
    totalCount() {
      return (
        (this.notifications &&
          this.notifications.reduce(
            (sum, notification) => sum + notification.count,
            0
          )) ||
        "0"
      );
    },
  },
  methods: {
    ...mapActions("adminnotification", [
      ADMINNOTIFICATION__ACTIONS.ADMINGETNOTIFICATION,
      ADMINNOTIFICATION__ACTIONS.ADMINUPDATENOTIFICATION,
      ADMINNOTIFICATION__ACTIONS.ADMINMARKASREADNOTIFICATION,
      ADMINNOTIFICATION__ACTIONS.SET_POLLING_INTERVAL,
      ADMINNOTIFICATION__ACTIONS.STOP_POLLING_INTERVAL,
    ]),
    navigateToPage(item) {
      let route = "";
      let payload = {};

      switch (item.type) {
        case "kyc_upload":
          route = "/registered-user?tab=2";
          payload = { kyc_upload: 0 };
          break;
        case "live_account":
          route = "/registered-user?tab=3";
          payload = { live_account: 0 };
          break;
        case "tradable_bonus_account":
          route = "/tradable-bonus-history";
          payload = { tradable_bonus_account: 0 };
          break;
        case "deposit":
          route = "/deposit";
          payload = { deposit: 0 };
          break;
        case "withdrawal":
          route = "/withdraw";
          payload = { withdrawal: 0 };
          break;
        case "ib_withdrawal":
          route = "/withdraw-requests";
          payload = { ib_withdrawal: 0 };
          break;
        case "register":
          route = "/registered-user?tab=1";
          payload = { register: 0 };
          break;
        case "internal_transfer":
          route = "/internal-transctions";
          payload = { internal_transfer: 0 };
          break;
        case "demo_account":
          route = "/registered-user?tab=4";
          payload = { demo_account: 0 };
          break;
        case "manager_account":
          route = "/managers";
          payload = { manager_account: 0 };
          break;
        case "investor_account":
          route = "/investors";
          payload = { investor_account: 0 };
          break;
        case "ticket":
          route = "/support";
          payload = { ticket: 0 };
          break;
        case "contest_account":
          route = "/contest";
          payload = { contest_account: 0 };
          break;
        default:
          console.warn("Unknown notification type:", item.type);
          return;
      }

      this[ADMINNOTIFICATION__ACTIONS.ADMINUPDATENOTIFICATION](payload);

      this.$router.push(route);
    },

    markAllAsRead() {
      this[ADMINNOTIFICATION__ACTIONS.ADMINMARKASREADNOTIFICATION]();
    },
  },

  created() {
    this[ADMINNOTIFICATION__ACTIONS.SET_POLLING_INTERVAL]();
  },
  beforeDestroy() {
    this[ADMINNOTIFICATION__ACTIONS.STOP_POLLING_INTERVAL]();
  },
};
</script>
